// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__3Ge-C"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 153
// module chunks = 0